import {Switch} from 'react-router-dom';
import {PropsRoute} from '@core/app/Routes';
import PublisherIndex from './publisher';

const PublishersIndex = ({user, organization}) => {
  return (
    <Switch>
      <PropsRoute
        path='/:part(a|s|b|p)/:slug/research/publishers/:publisherSlug'
        user={user}
        organization={organization}
        component={PublisherIndex}
      />
    </Switch>
  );
};

export default PublishersIndex;
